<template>
  <div class="content">
    <img src="../assets/money.png" class="moneyImg">
    <div class="money col-green f-40">购物奖励</div>
    <!-- 红包 -->
    <redBox :isList="false" @openRedbox="openRedbox"></redBox>

    <!-- 离开弹窗 -->
    <popup ref="popup">
      <div class="coupon-main t-center bg-ff">
        <div class="col-green f-58 green-word">300元补贴金</div>
        <div class="col-99 f-38 leave-word">离开后您将失去领取资格</div>
        <div class="f-32 dis-flex flex-x-between btn-box">
          <div class="leave-btn col-green" @click="leaveAction">离开</div>
          <div class="use-btn col-ff bg-green" @click="useAction">立即使用</div>
        </div>
      </div>
      <div class="line bg-ff">
        <div class="line-dashed"></div>
      </div>
      <div class="bottom-box bg-ff">
        <div class="f-24 col-99 row-item">
          <div class="row-name">有效期</div>
          <div class="row-info">{{nowTime}} 00:00 - {{endTime}} 23:59</div>
        </div>
        <div class="f-24 col-99 row-item">
          <div class="row-name">重要说明</div>
          <div class="row-info">本次购物补贴可用与活动商品购买时立减使用。</div>
        </div>
      </div>
      
    </popup>
  </div>
</template>

<script>
import {addCard} from '@/utils/addCard'
import redBox from '@/components/redBox.vue'
import popup from '@/components/popup.vue'
import {getCodeUrl, getUrlCode, getOpenId,getChannelRec,_getUrlParam,_getStatePar,_getState} from '@/utils/util'
export default {
  components: {
    redBox: redBox,
    popup: popup
  },
  name: "coupon",
  data() {
    return {
      isRotate: false,
      nowTime: '00-00-00',
      endTime: '00-00-00',
      pathId:"",
      openId:null
    }
  },
  beforeRouteEnter (to, from, next) {
    console.log('beforeRouteEnter')
     console.log("window.location",window.location);
    // // 非微信浏览器打开
    // let ua = navigator.userAgent.toLowerCase(); 
    // let isNotWechat = ua.match(/MicroMessenger/i) !== "micromessenger"


    // console.log('微信环境：', isNotWechat, 'ua.match(/MicroMessenger/i)', ua.match(/MicroMessenger/i))
    // if (!isNotWechat) {
    //   // 获取code
    //   let userCode = window.sessionStorage.getItem('userCode')
    //   console.log('userCode', userCode)
    //   if (!userCode)  getUrlCode()
    // }

    // let isNotFirst = window.sessionStorage.getItem('isNotFirst')
    // console.log('isNotFirst', isNotFirst)
    // if (isNotFirst || isNotWechat) {
    //   next()
    // } else {
    //   addCard(next)
    // }
   
    let isNotFirst = window.sessionStorage.getItem('isNotFirst')
    console.log('isNotFirst', isNotFirst)

    if (isNotFirst) {
      next()
    } else {
      //-----------------2.3------------------------------
         //获取pathid
      let _state= _getState(window.location.href)
      let pathId = null
      if (_state) {  //如果参数pathid再state中
        pathId = _getStatePar(_state,"channels_id");
      }else{
         pathId = _getUrlParam(window.location.href,"channels_id");
      }
      console.log("pathId",pathId);
     //-------------------------------------
      window.sessionStorage.setItem('isNotFirst', true)
      addCard(next,pathId)
    }

    // // 获取openid
    // let that = this
    // let openid = window.localStorage.getItem('openid')
    // console.log('openid', openid)
    // if (!openid) {
    //   getUrlCode()
    // }
  },
  methods: {
    leaveAction () {
        _czc.push(["_trackEvent","渠道id"+this.pathId+"离开页面-h5","点击弹窗【离开】按钮"]) //点击弹窗【离开】按钮渠道埋点
      this.$refs.popup.hidePopup()
    },
    useAction () {
      console.log('点击立即使用')
       _czc.push(["_trackEvent","渠道id"+this.pathId+"离开页面-h5","点击弹窗【立即使用】按钮"]) //点击弹窗【立即使用】按钮渠道埋点
      window.sessionStorage.setItem('isList', true)
      this.goList()
    },
    openRedbox () {
      // console.log('点击了开启红包', this.$Toast('提示'))
       _czc.push(["_trackEvent","渠道id"+this.pathId+"离开页面-h5","点击红包【开】按钮"]) //点击红包【开】按钮渠道埋点
      this.goList()
    },
    goList () {
      // let data = {redbag: '123456'}
      let data = {}
      if (this.pathId){
        data.channels_id=this.pathId
        data.notFirst = 1
        }
      this.$router.push({name: 'couponlist', query: data})
    },
    //-----------------2.3------------------------------
    getUrlParam(val,name) {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      let _val = val.split("?")[1]
      if (!_val) {
        return null
      }
      var r = _val.match(reg);//search,查询？后面的参数，并匹配正则
      console.log("_val",_val);
     if(r!=null)return  unescape(r[2]); return null;
    },
    getStatePar(val,name){
     let reg = new RegExp("(^|/)"+ name +"=([^/]*)(/|$)")
     let r = val.match(reg)
      console.log("val",val);
     if(r!=null)return  unescape(r[2]); return null;
    },
    getState(val){
      // let reg =  /(?<=state=).+(?=#)/
      // let r = decodeURIComponent(val).match(reg)
      // console.log("stateR",r);
      // if(r!=null)return  unescape(r[0]); return null;
        var reg = new RegExp("(^|&)"+ "state" +"=([^&]*)(&|$)");
        let r = decodeURIComponent(val).match(reg)
        if(r!=null)return  unescape(r[2].substr(0,r[2].length-2)); return null;
    },
    handlePath(flag){  //处理渠道id的问题
      //--------2.3获取渠道id-------------------
      if (flag) {
        let _state= this.getState(window.location.href)
        if (_state) {
          this.handlePath()
        }else{
          this.pathId = this.getUrlParam(window.location.href,"channels_id");
           let tag = this.getUrlParam(window.location.href,"tag")  //判断是否为落地页
           if (tag) {  getChannelRec(this.openId,this.pathId)};
            _czc.push(["_trackEvent","渠道id"+this.pathId+"离开页面-h5","进入页面"])
           console.log("this.pathId",this.pathId,"tag",tag);
        }
      
        return
      }
      let state= this.getState(window.location.href)
      this.pathId = this.getStatePar(state,"channels_id");
      let tag = this.getStatePar(state,"tag")  //判断是否为落地页
      if (tag) {  getChannelRec(this.openId,this.pathId)};
       _czc.push(["_trackEvent","渠道id"+this.pathId+"离开页面-h5","进入页面"])
      console.log("this.pathId",this.pathId,"tag",tag);
      //---------------------------------------
    },
    //---------------------------------------
  },
  beforeMount () {
    let that = this
    let nowTime = new Date()
    let nowY = nowTime.getFullYear(),
      nowM = nowTime.getMonth() + 1,
      nowD = nowTime.getDate();

    nowTime = Date.parse(new Date(nowTime))

    // let endTime = nowTime + (7 * 24 * 3600000)
    let endTime = nowTime + (6 * 24 * 3600000)  // 显示是当天0点到结束日24点，所以是7-1天
    endTime = new Date(endTime)
    let endY = endTime.getFullYear(),
      endM = endTime.getMonth() < 9 ? `0${endTime.getMonth() + 1}`: endTime.getMonth() + 1,
      endD = endTime.getDate() < 10 ? `0${endTime.getDate()}`: endTime.getDate();

    that.nowTime =  `${nowY}-${nowM}-${nowD}`
    that.endTime =  `${endY}-${endM}-${endD}`

      
  },
  created(){  //清除列表页红包弹窗
   // 获取openid
    let that = this
    let openid = window.localStorage.getItem("openid");
    console.log("****openid*****", openid);
    if (!openid) {
      getUrlCode(res=>{
        that.openId = res
         this.handlePath()
      })
    }else{
        this.openId =  openid
          this.handlePath(1)
    }
  
  //  _czc.push(["_trackEvent","离开页面-h5","进入页面","渠道id",this.pathId])
   window.localStorage.removeItem("isFirstShowRedBag")
  },
  mounted () {
    let that = this
    let isNotFirst = window.sessionStorage.getItem('isNotFirst')
    console.log('mounted的isNotFirst', isNotFirst)

    // this.$refs.popup.showPopup()

    // 点击弹窗立即使用返回这个页面
    let isList =  window.sessionStorage.getItem('isList')
    if (isList) {
      that.$refs.popup.showPopup()
      window.sessionStorage.setItem('isList', null)
    }

    // 关闭卡券
    document.addEventListener('visibilitychange', 
      ()=> {
      if (document.visibilityState != 'hidden') {
        _czc.push(["_trackEvent","渠道id"+this.pathId+"卡券领取页面","退出领取页面"])
        let openCardTime = window.localStorage.getItem('openCardTime') || null
        if (openCardTime) {
            let gapTime = Math.ceil((Date.now() - openCardTime)/1000)
           _czc.push(["_trackEvent","渠道id"+this.pathId+"卡券领取页面","停留时长",gapTime+"s"])
           window.localStorage.removeItem("openCardTime")
        }
        that.$refs.popup.showPopup()
      }
    });
  },
  destroyed() {
     _czc.push(["_trackEvent","渠道id"+this.pathId+"商品列表页-h5","离开页面"])
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../style/common.less';
.f-bold{font-weight: bold;}
.f-32{font-size: .32rem;line-height: 45rpx;}
.f-40{font-size: .40rem;line-height: 56rpx;}
.content{
  text-align: center;
  .moneyImg{
    padding: .59rem 0 .12rem;
    height: 0.8rem;
    width: 0.8rem;
  }
  .money{
    margin-bottom: .46rem;
  }
}
// 补贴金弹窗
.coupon-main{
  box-sizing: border-box;
  padding-top: .69rem;
  height: 4.36rem;
  width: 7.1rem;
  background: #fff;
  border-radius: .24rem .24rem 0 0;
  overflow: hidden;
  box-sizing: border-box;
  .green-word{
    line-height: .61rem;
    margin-bottom: .27rem;
  }
  .leave-word{
    line-height: .4rem;
  }
  .btn-box{
    padding: .88rem .3rem .86rem;
    .leave-btn, .use-btn{
      height: .96rem;
      width: 3.0rem;
      line-height: .96rem;
      border: 1px solid #55B374;
      border-radius: .08rem;
      font-size: 0.34rem;
    }  
  }
}
.line{
  position: relative;
  padding: 0 0.35rem;
  box-sizing: border-box;
  height: .3rem;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  line-height: .3rem;
  color: #D5D5D5;
  .line-dashed{
    height: 0.01rem;
    width: 100%;
    margin-top: .14rem;
    border-top: 0.02rem dashed #D5D5D5;
  }
  &:before{
    display: block;
    position: absolute;
    top: 0;
    left: -0.15rem;
    content: '';
    height: 100%;
    // width: .3rem;
    width: .27rem;
    background: rgba(0,0,0,0.7);
    border-radius: 50%;
  }
  &:after{
    display: block;
    position: absolute;
    top: 0;
    right: -0.15rem;
    content: '';
    height: 100%;
    // width: .3rem;
     width: .27rem;
    background: rgba(0,0,0,0.7);
    border-radius: 50%;
  }
}
.bottom-box{
    width: 100%;
    box-sizing: border-box;
    padding: 0.21rem .29rem 0;
    border-radius: 0 0 .24rem .24rem;
    height: 1.92rem;
    .row-item{
      display: flex;
      margin-bottom: .16rem;
      line-height: .4rem;
      text-align: left;
      .row-name{
        width: 1.42rem;
      }  
    }
    
  }
</style>
